<div
    *ngIf="toast()?.visible"
    class="fixed z-50 max-w-fit transform"
    [ngClass]="toastPositionClasses()"
>
    <stria-alert [type]="toast()?.type" [appearance]="'fill'">
        <span striaAlertTitle>{{ toast()?.message }}</span>
    </stria-alert>
</div>
 